export default __webpack_public_path__ + "static/wpAdPageBannerMobile-181bcc8fd7046aab2023ff98d6c79c0d.webp";